// extracted by mini-css-extract-plugin
export default {"wrapper":"TotalLabel_wrapper__oHYBW","label":"TotalLabel_label__LbhW2","value":"TotalLabel_value__6JI5w"};